import { useState, useEffect } from "react";
import { MdAddHome } from "react-icons/md";
import { useNavigate, useLocation } from "react-router-dom";
import { updateInquiry } from "../../../../Service/RM";
import { showToast } from "../../../../reusableUI/toaster";
import { getLookupData, getPincodeDetails } from "../../../../Service/lookup";
import Loader from "../../../../reusableUI/loader";
import AddressDetailForm from "../../../../reusableUI/address";
import { CommonImages } from "../../../../reusableUI/images";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const Partner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedRole = location.state?.enquiryRole;
  const [hospitalName, setHospitalName] = useState("");
  const [hospitalSlogan, setHospitalSlogan] = useState("");
  const [noOfPatient, setNoOfPatient] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [country, setCountry] = useState("");
  const [toastMsg, setToastMsg] = useState(null);
  const [casedata, setCase] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [selectedDates, setSelectedDates] = useState([]);
  const [validOne, setValidOne] = useState(false);

  const timeSlots = [
    "09:00 AM - 12:00 PM",
    "12:00 PM - 03:00 PM",
    "03:00 PM - 06:00 PM",
    "06:00 PM - 09:00 PM",
  ];

  const daySlots = ["Mon", "Tue", "Wed", "Thu", "Fri"];

  useEffect(() => {
    getCase();

    if (pinCode.length > 5) {
      getPincode(pinCode);
    }
  }, [state, pinCode]);

  const getCase = async () => {
    const result = await getLookupData();
    if (result.error === false) {
      setCase(result.data);
    } else {
      console.log("Error fetching");
    }
  };

  const getPincode = async (code) => {
    try {
      console.log(code);
      const result = await getPincodeDetails(code);

      if (result && result.error === false) {
        console.log(result.data);
        setState(result.data.state);
        setCity(result.data.district);
      } else {
        console.log("Error fetching");
      }
    } catch (error) {
      console.error("Exception while fetching districts:", error);
    }
  };
  console.log(state, city);

  // const stateOptions = stateList.map((item) => ({ value: item, label: item }));

  const caseList = casedata.filter((item) => item.type === "phonecode");
  const caseTitle = casedata.filter((item) => item.type === "title");

  const defaultContact = {
    department: "",
    title: "",
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    code: "91",
    phone: "",
    WpCode: "91",
    whatsapp: "",
  };

  const [contacts, setContacts] = useState([{ ...defaultContact }]);

  const handleDay = (slot) => {
    if (selectedDates.includes(slot)) {
      setSelectedDates(selectedDates.filter((s) => s !== slot));
    } else {
      setSelectedDates([...selectedDates, slot]);
    }
  };

  const handleChange = (index, field, value) => {
    const updatedContacts = [...contacts];
    updatedContacts[index][field] = value;
    setContacts(updatedContacts);
  };

  const isContactFilled = (contact) => {
    return (
      contact.title.trim() !== "" &&
      contact.firstName.trim() !== "" &&
      contact.email.trim() !== "" &&
      contact.phone.trim() !== ""
    );
  };

  const isAddButtonEnabled =
    contacts.length > 1 || isContactFilled(contacts[0]);

  const SaveHospital = async () => {
    if (!hospitalName.trim()) {
      showToast(`${selectedRole} Name is required`, "Error");
      return;
    }

    if (!addressLine1.trim()) {
      showToast("Address Line 1 is required", "Error");
      return;
    }

    if (addressLine1.trim().length < 12 || addressLine1.trim().length > 255) {
      showToast("The Address must be between 12 and 255 characters.", "Error");
      return;
    }

    if (!pinCode.trim()) {
      showToast("Pin Code is required", "Error");
      return;
    }

    if (!state.trim()) {
      showToast("State is required", "Error");
      return;
    }

    if (!city.trim()) {
      showToast("City is required", "Error");
      return;
    }

    if (!/^\d{6,}$/.test(pinCode.trim())) {
      showToast("Pin Code must be at least 6 digits.", "Error");
      return;
    }

    if (contacts.length === 0) {
      showToast(
        "At least one contact person information is required.",
        "Error"
      );
      return;
    }

    const validateContact = (contact, index) => {
      const contactNum = index + 1;

      if (!contact.title?.trim()) {
        showToast(`Contact ${contactNum}: Title is required.`, "Error");
        return false;
      }

      if (!contact.firstName?.trim()) {
        showToast(`Contact ${contactNum}: Fullname is required.`, "Error");
        return false;
      }

      if (!contact.phone?.trim()) {
        showToast(`Contact ${contactNum}: Phone Number is required.`, "Error");
        return false;
      }

      if (contact.phone.trim().length < 10) {
        showToast(
          `Contact ${contactNum}: Phone Number must be at least 10 digits.`,
          "Error"
        );
        return false;
      }

      return true;
    };

    let atLeastOneValid = false;

    for (let i = 0; i < contacts.length; i++) {
      const isValid = validateContact(contacts[i], i);
      if (!isValid) return;
      atLeastOneValid = true;
    }

    if (!atLeastOneValid) {
      showToast("At least one valid contact person is required.", "Error");
      return;
    }

    if (selectedDates.length === 0) {
      showToast("Preferred Day is required.", "Error");
      return;
    }

    if (!selectedSlot) {
      showToast("Preferred timing slot is required.", "Error");
      return;
    }

    const data = {
      partnerType: selectedRole,
      preferredConnection: {
        days: selectedDates,
        time: selectedSlot,
      },

      basicInfo: {
        name: hospitalName,
        slogan: hospitalSlogan,
        beds: noOfPatient,
      },
      addressInfo: {
        address1: addressLine1,
        address2: addressLine2,
        city: city,
        state: state,
        pincode: Number(pinCode),
      },
      contactPersonInfo: contacts.map((c) => ({
        nameInfo: {
          title: c.title,
          fullName: c.firstName,
        },
        phone: Number((c.code + c.phone).replace(/\s+/g, "")),
        email: c.email,
        whatsappNumber: Number((c.WpCode + c.whatsapp).replace(/\s+/g, "")),
      })),
    };

    console.log("Transformed Data:", data);
    setLoading(true);

    try {
      const res = await updateInquiry(data);

      if (res.error === false) {
        showToast(
          "Thanks for submitting. We will get back to you soon",
          "Success"
        );
        setHospitalName("");
        setHospitalSlogan("");
        setNoOfPatient("");
        setAddressLine1("");
        setAddressLine2("");
        setCity("");
        setState("");
        setPinCode("");
        setCountry("");
        setSelectedSlot("");
        setSelectedDates("");
        setContacts([{ ...defaultContact }]);

        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        showToast(res.message, "Error");
      }
    } catch (error) {
      console.error("Save error:", error);
      showToast("Something went wrong while saving data", "Error");
    } finally {
      setLoading(false);
    }
  };

  const renderContactForm = (contact, index) => (
    <div className="w-full mb-1" key={index}>
      <div className="p-4 rounded">
        <div
          className={`flex flex-row  items-center gap-4 w-full justify-start`}
        >
          {/* <div>
            <label className="text-[13px] text-[#606060] mb-1 block font-poppins">
              Department <a className="text-[red]">*</a>
            </label>
            <input
              type="text"
              className="border px-2 py-1.5 border-[#D2D2D2] rounded-r-sm rounded-sm text-[12px]  font-poppins"
              placeholder=""
              value={contact.department}
              onChange={(e) => {
                const value = e.target.value;
                const capitalized =
                  value.charAt(0).toUpperCase() + value.slice(1);
                handleChange(index, "department", capitalized);
              }}
            />
          </div> */}

          <div>
            <div className="flex flex-row items-center gap-10">
              <label className="text-[13px] font-poppins text-[#606060] block mb-1">
                Title
              </label>
              <label className="text-[13px] font-poppins text-[#606060] block mb-1">
                Full Name (as per Aadhaar){" "}
                <a className="font-poppins text-[red]">*</a>
              </label>
            </div>
            <div className="flex  w-[360px]">
              <div className="relative w-[80px]">
                <select
                  className={`appearance-none w-full border border-[#D2D2D2] px-2 py-1.5 rounded-sm text-[12px] text-[#606060] font-poppins`}
                  value={contact.title}
                  onChange={(e) => handleChange(index, "title", e.target.value)}
                >
                  <option hidden></option>
                  {caseTitle.map((item, index) => (
                    <option key={`${item.value}-${index}`} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>

                <div
                  className={`pointer-events-none absolute inset-y-0 right-2 flex items-center justify-center ${
                    contact.title ? "" : "mr-4"
                  }`}
                >
                  <svg
                    className="w-4 h-4 text-[#606060]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.66a.75.75 0 01-1.08 0l-4.25-4.66a.75.75 0 01.02-1.06z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>

              <input
                type="text"
                className="w-[100%] border border-1 border-[#D2D2D2] px-2 py-1 rounded-r-sm text-[12px]  font-poppins"
                placeholder=""
                value={contact.firstName}
                onChange={(e) => {
                  const val = e.target.value;
                  const capitalized =
                    val.charAt(0).toUpperCase() + val.slice(1);
                  handleChange(index, "firstName", capitalized);
                }}
              />
            </div>
          </div>

          <div>
            <div className="flex flex-row items-center gap-8">
              <label className="text-[13px] font-poppins text-[#606060] block mb-1">
                Phone <a className="text-[red]">*</a>
              </label>
            </div>
            <div className="flex">
              <select
                className="w-[60px] border border-1 border-[#D2D2D2]  px-2 py-1.5 rounded-l-sm rounded-sm text-[12px] text-[#606060] font-poppins"
                value={contact.code}
                onChange={(e) => handleChange(index, "code", e.target.value)}
              >
                {caseList.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              <input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                className="border border-1 border-[#D2D2D2] px-2 py-1.5 rounded-r-sm text-[12px]  font-poppins"
                maxLength={10}
                value={contact.phone}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    handleChange(index, "phone", value);
                  }
                }}
              />
            </div>
          </div>

          <div>
            <div className="flex flex-row items-center gap-8">
              <label className="text-[13px] font-poppins text-[#606060] block mb-1">
                Whatsapp Number
              </label>
            </div>
            <div className="flex">
              <select
                className="w-[60px] border border-1 border-[#D2D2D2]  px-2 py-1.5 rounded-l-sm rounded-sm text-[12px] text-[#606060] font-poppins"
                value={contact.WpCode}
                onChange={(e) => handleChange(index, "WpCode", e.target.value)}
              >
                {caseList.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              <input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                className="border border-1 border-[#D2D2D2] px-2 py-1.5 rounded-r-sm text-[12px]  font-poppins"
                maxLength={10}
                value={contact.whatsapp}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    handleChange(index, "whatsapp", value);
                  }
                }}
              />
            </div>
          </div>

          <div>
            <label className="text-[13px] text-[#606060] block mb-1 font-poppins">
              Email
              {/* <a className="text-[10px] text-[#5B60A8] font-poppins">
                (optional)
              </a> */}
            </label>
            <input
              type="email"
              className={`border border-1 border-[#D2D2D2]  px-2 py-1.5 rounded-sm text-[12px]  font-poppins ${"w-[240px]"}`}
              value={contact.email}
              onChange={(e) => handleChange(index, "email", e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const AddInfo = () => {
    setContacts([...contacts, { ...defaultContact }]);
  };
  return (
    <div className="">
      {loading ? (
        <div className="">
          <Loader loading={loading} />
        </div>
      ) : (
        <div className="p-2">
          <img
            src={CommonImages.CevIcon}
            className="w-[145px] h-[36px] mx-auto my-2 mb-4"
          />
          <div className="bg-[#4951EC] text-white p-4 rounded-t-[10px] flex justify-between items-center ">
            <div className="flex items-center gap-1">
              <MdAddHome size={22} />
              <h2 className="text-[14px] font-poppins">Partnership Inquiry</h2>
            </div>
            <div className="flex gap-2">
              <button
                className="border hover:bg-blue-700 text-white font-poppins text-[14px] px-4 py-1 rounded-sm"
                onClick={() => {
                  SaveHospital();
                }}
              >
                Submit
              </button>

              <button
                className="bg-[#fff] text-[#4951EC] text-[14px] font-poppins px-4 py-1 rounded-sm"
                onClick={() => {
                  const confirmBack = window.confirm(
                    "Are you sure you want to go back?"
                  );
                  if (confirmBack) {
                    navigate("/roleSelection");
                  }
                }}
              >
                Back
              </button>
            </div>
          </div>

          <div className="bg-white  overflow-y-auto h-[75vh]   pb-[100px] p-4 rounded-b-[20px] shadow-lg">
            <h3 className="text-sm font-semibold mb-4 font-poppins text-[#3B3B3B]">
              {selectedRole === "Hospital" && "Hospital General Information"}
              {selectedRole === "Agency" && "Agency General Information"}
              {selectedRole === "Company" && "Company General Information"}
            </h3>
            <div className="mb-6">
              <div className="grid grid-cols-1 md:grid-cols-5 gap-2 mb-8">
                <div>
                  <p className="mb-1 text-[13px] text-[#606060] font-poppins">
                    {selectedRole} Name
                    <a className="text-[red]">*</a>
                  </p>
                  <input
                    type="text"
                    // placeholder="Hospital Name"
                    value={hospitalName}
                    onChange={(e) => {
                      const value = e.target.value;
                      const capitalized =
                        value.charAt(0).toUpperCase() + value.slice(1);
                      setHospitalName(capitalized);
                    }}
                    className="border border-1 border-[#D2D2D2]  text-[12px] p-1.5 rounded-sm w-full  font-poppins"
                  />
                </div>
                {selectedRole === "Hospital" && (
                  <div>
                    <p className="mb-1 text-[13px] text-[#606060] font-poppins">
                      Hospital Slogan
                      <a className="text-[10px] text-[#5B60A8]">(optional)</a>
                    </p>
                    <input
                      type="text"
                      // placeholder="Hospital Slogan"
                      value={hospitalSlogan}
                      onChange={(e) => setHospitalSlogan(e.target.value)}
                      className="border border-1 border-[#D2D2D2]  text-[14px] p-1 rounded-sm w-full"
                    />
                  </div>
                )}

                {selectedRole === "Hospital" && (
                  <div>
                    <p className="mb-1 text-[13px] text-[#606060] font-poppins">
                      No of Beds{" "}
                      <a className="text-[10px] text-[#5B60A8] font-poppins">
                        (optional)
                      </a>
                    </p>
                    <input
                      type="number"
                      // placeholder="No of Patient"
                      value={noOfPatient}
                      onChange={(e) => setNoOfPatient(e.target.value)}
                      className="border border-1 border-[#D2D2D2]  text-[14px] p-1 rounded-sm w-full"
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Address Details */}
            <AddressDetailForm
              addressLine1={addressLine1}
              setAddressLine1={setAddressLine1}
              addressLine2={addressLine2}
              setAddressLine2={setAddressLine2}
              state={state}
              setState={setState}
              city={city}
              setCity={setCity}
              pinCode={pinCode}
              setPinCode={setPinCode}
              country={country}
              setCountry={setCountry}
              // stateList={stateList}
              // districtList={districtList}
              role={selectedRole}
            />

            <h3 className="text-sm font-poppins font-semibold mb-4 text-[#3B3B3B]">
              Contact Person Information
            </h3>
            <div className="flex flex-row items-start justify-start border rounded-sm ">
              <div className=" mb-4 ">
                {contacts.map((contact, index) =>
                  renderContactForm(contact, index)
                )}
              </div>
              <div
                onClick={isAddButtonEnabled ? AddInfo : null}
                className={`rounded-full text-white text-[18px] mt-10 h-8 w-8 flex justify-center items-center ml-20 cursor-pointer transition
    ${
      isAddButtonEnabled
        ? "bg-[#254d7d] hover:bg-[#1f3f66]"
        : "bg-gray-400 cursor-not-allowed"
    }`}
              >
                +
              </div>
            </div>

            <h3 className="text-sm font-poppins font-semibold mb-4 text-[#3B3B3B] mt-8 pb-2">
              Preferred Day & Time to connect
            </h3>

            <div className="flex flex-wrap gap-5 mt-2">
              {daySlots.map((slot, index) => (
                <button
                  key={index}
                  onClick={() => handleDay(slot)}
                  className={`px-4 py-1.5 border rounded-sm font-poppins text-[12px] transition 
        ${
          selectedDates.includes(slot)
            ? "bg-blue-600 text-white border-blue-500"
            : "border-gray-300 text-[#3B3B3B] hover:bg-blue-100"
        }`}
                >
                  {slot}
                </button>
              ))}
            </div>

            <div className="flex flex-wrap gap-5 mt-8">
              {timeSlots.map((slot, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedSlot(slot)}
                  className={`px-4 py-1.5 border rounded-sm font-poppins text-[12px] transition 
              ${
                selectedSlot === slot
                  ? "bg-blue-600 text-white border-blue-500"
                  : "border-gray-300 text-[#3B3B3B] hover:bg-blue-100"
              }`}
                >
                  {slot}
                </button>
              ))}
            </div>
          </div>

          {/* {toastMsg && <Toaster action={toastMsg.action} msg={toastMsg.msg} />} */}
        </div>
      )}
    </div>
  );
};

export default Partner;
